import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { decodeString, twoDecimal, productHelper } from '../../utils/helper';
import { withRouter } from 'react-router-dom';
import ProductMedia from './ProductMedia';
import ProductRatingCard from './ProductRatingCard';
import FeedShare from '../../assets/images/products/feed-share.svg';
import SharePopUp from '../SharePopUp';
import { productLinks } from '../../utils/internalLinks';
import ReadMoreText from '../../containers/loggedIn/Feed/common/ReadMoreText';
import PaidRibbon from '../../components/profile/MyPassbook/PaidRibbon';
import { showProfilePassbookModal } from '../../actions/common/modals';
import {startPublicReview } from '../../actions/products';

const ProductMetaInfo = ({
  product,
  meta,
  history,
  isPublic,
  publicClickAction,
  toggleShareAPostModal,
  showProfilePassbookModal,
  fillProductMandatoryCheck,
 startPublicReview,
  handleClickButton,
  token
}) => {
  const isPaid = get(meta, 'isPaid');
  const {
    name,
    images_meta,
    brand_name,
    brand_logo,
    type,
    description,
    id,
    video_link,
    keywords,
    not_accepting_response,
    videos_meta,
    assets_order
  } = product;

  const overallRating = meta && meta.overall_rating ? meta.overall_rating : null,
    currentStatus = meta && meta.current_status ? meta.current_status : 0,
    count = overallRating && overallRating.count ? overallRating.count : 0,
    overallRatingUnavailable = overallRating && !overallRating.overall_rating,
    currentStatusText = productHelper.statusText(currentStatus),
    reviewTextToShow = productHelper.reviewText(count, overallRatingUnavailable);
  const [showPopUp, setShowPopUp] = useState(false);

  useEffect(() => {
    document.addEventListener('click', function () {
      setShowPopUp(false);
    });
    return function cleanup() {
      document.removeEventListener('click', () => { });
    };
  }, []);

  function handleClick(currentStatus) {
    if (currentStatus === 2) return;
    if (currentStatus === 0) {
      if (isPaid) {
        showProfilePassbookModal('beforeStartReview', {
          modalType: 'productReview',
          data: {
            id,
            linkTo: productLinks.reviewLink(id),
            continueButtonAction: fillProductMandatoryCheck,
          },
        });
      } else {
        fillProductMandatoryCheck();
      }
      return;
    }
    startPublicReview(token, product.id).then((res) => {
      if (res && !!res.data.status) {
        history.push(productLinks.reviewLink(id));
      } else if (res && !!res.errors.status) {
        let { errors } = res;
        const directLink = productLinks.all;
        alert(errors && errors.display_message || "Something went wrong");
        return history.replace(directLink)
      } else {
        handleClickButton("resume");
      }
    })
  }
  function toggleShareAPost() {
    toggleShareAPostModal({ product, meta, type: 'product' });
  }

  return (
    <>
      {isPaid && (
        <div className="productinfo__ribbon">
          <PaidRibbon />
        </div>
      )}
      <div className="product__meta">
        <div className="product__media">
          <ProductMedia images={images_meta} video={video_link} videosMeta={videos_meta || []}
            assetOrder={Array.isArray(assets_order) && assets_order.length && assets_order || ["videos", "images"]} />
        </div>
        <div className="product__meta__details">
          <div className="product__meta__details__type">
            <div>
              {brand_logo && Array.isArray(brand_logo) && brand_logo.length ? <img src={brand_logo.original_photo} alt={`${brand_name} brand`} /> : null}
              {brand_name && (
                <p
                  className={`product__meta__details__type__title ${brand_logo ? 'product__meta__details__type__title--margin' : ''
                    }`}
                >
                  {brand_name}
                </p>
              )}
            </div>
            {type && type.image && <img src={type.image} alt={type.value} />}
          </div>
          {name && <p className="product__title">{decodeString(name)}</p>}
          {keywords && !!keywords.length && (
            <ul className="product__keywords__list">
              {keywords.map((_, index) => {
                const keyword = decodeString(_.value);
                return (
                  <li className="product__keywords__list__item" key={`product-category-${index}`}>
                    {keyword}
                  </li>
                );
              })}
            </ul>
          )}
          {overallRating && (
            <div className="product__meta__rating">
              <ProductRatingCard
                maxRating={overallRating.overall_rating ? overallRating.max_rating : null}
                backgroundColor={overallRating.color_code}
                ratingUnavailable={!overallRating.overall_rating}
                containerClass="product__ratings__default"
                ratingToShow={
                  overallRating.overall_rating ? twoDecimal(overallRating.overall_rating) : 0
                }
              />
              <p className="product__meta__rating__title">{reviewTextToShow}</p>
            </div>
          )}
          <div className="product__action__container">
            <button
              onClick={() => {
                if (isPublic) {
                  publicClickAction();
                  return;
                }
                handleClick(currentStatus);
              }}
              className={`product__action__btn ${currentStatus === 2 || not_accepting_response === 1
                  ? 'product__action__btn--disabled'
                  : ''
                }`}
              disabled={currentStatus === 2 || not_accepting_response === 1}
            >
              {currentStatusText.fullText}
            </button>
            <button
              onClick={(e) => {
                e.nativeEvent.stopImmediatePropagation();
                if (isPublic) {
                  publicClickAction();
                  return;
                }
                setShowPopUp(!showPopUp);
              }}
              className="product__action__share"
            >
              <img src={FeedShare} alt="share" />
            </button>
            {showPopUp && (
              <SharePopUp postId={product.id} shareOnFeed={toggleShareAPost} postType="product" />
            )}
          </div>
        </div>
      </div>
      {description && !!description.trim().length && (
        <ReadMoreText
          className="product__section product__description"
          isOpen={false}
          text={description}
        />
      )}
    </>
  );
};

function mapStateToProps(state) {
  return {
    token: state.login.token,
  };
}

const mapDispatchToProps = {
  showProfilePassbookModal,
 startPublicReview
};

ProductMetaInfo.propTypes = {
  product: PropTypes.object.isRequired,
  meta: PropTypes.object,
  toggleShareAPostModal: PropTypes.func,
  showProfilePassbookModal: PropTypes.func,
  history: PropTypes.object,
  isPublic: PropTypes.bool,
  publicClickAction: PropTypes.func,
  fillProductMandatoryCheck: PropTypes.func,
  not_accepting_response: PropTypes.number,
  admin_note: PropTypes.string,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProductMetaInfo));
